import axios from "axios";
import Links from "../constants/Links";

const buildParams = ({ sessionId, semesterId, standaloneFeeId } = {}) => {
    const params = { session: sessionId };

    if (semesterId != null) {
        params.semester = semesterId;
    }
    if (standaloneFeeId != null) {
        params.standalone_fee = standaloneFeeId;
    }

    return params;
};

const StandalonePaymentManagement = {
    items: async (filters) => {
        const params = buildParams(filters);
        delete params.standalone_fee;
        return axios.get(Links.standalonePaymentManagement.items, { params });
    },

    statistics: async (filters) => {
        return axios.get(Links.standalonePaymentManagement.statistics, {
            params: buildParams(filters),
        });
    },

    downloadReport: async (filters) => {
        return axios.get(Links.standalonePaymentManagement.report, {
            params: buildParams(filters),
            responseType: "blob",
        });
    },
};

export default StandalonePaymentManagement;
